import Axios from 'utils/axios';
import { put } from 'redux-saga/effects';
import * as Metadata from 'actions/Metadata';

export function* onGetRequest() {
  try {
    const list = yield Axios.get('/api/metadata/getAll?sort=metadataName');
    yield put(Metadata.onGetSuccess(list.data || []));
  } catch (error) {
    yield put(Metadata.onGetFailure({ message: error }));
  }
}

export function* onGetHobbiesRequest() {
  try {
    const list = yield Axios.get('/api/hobby/getAll');
    yield put(Metadata.onGetHobbiesSuccess(list.data || []));
  } catch (error) {
    yield put(Metadata.onGetHobbiesFailure({ message: error }));
  }
}

